import './PostGrid.css';
import { convertDateFormat } from '../../utility/dateFormat';
import { FaUser } from "react-icons/fa6";

function createPreview(body, wordLimit=15){
  if (!body || !Array.isArray(body)) {
    return "This post has no content yet.";
  }

  // Extract all text from the blocks, ignoring images and other non-text types.
  const text = body
    // Find all blocks of type 'block' that have children
    .filter(block => block._type === 'block' && block.children)
    // For each block, join the text of its children (spans)
    .map(block =>
      block.children
        .filter(child => child._type === 'span' && child.text)
        .map(span => span.text)
        .join('')
    )
    .join(' '); // Add a space between paragraphs

  // Split the combined text into words
  const words = text.split(/\s+/); // Split by any whitespace character

  // If the text is already shorter than the limit, return it as is
  if (words.length <= wordLimit) {
    return text;
  }

  // Otherwise, slice the array and add an ellipsis
  return words.slice(0, wordLimit).join(' ') + '...';
}

const PostPreview = ({post}) =>{
    let displayImage = 'block';
    if(post.image === 'none'){
        displayImage = 'none';
    }

    return(
        <a className='postPreview' href={`/posts/${post.slug.current}`}>
            <div className='postPreviewInfo'>
                <h5 className='postPreviewCategory'>
                    {post.category.title}
                </h5>
                <h4>{post.title}</h4>
                <h5 className='postPreviewDate'>{convertDateFormat(post.date)}</h5>
                <div className='postPreviewUsername'><FaUser/><p>{post.username}</p></div>
                <p className='postPreviewText'>{createPreview(post.body)}...</p>
            </div>
            <img className='postPreviewImage' style={{display: displayImage}} src={post.image} alt={post.imageAlt} />
        </a>
    )
}


export function PostGrid({posts}){
    if(!posts || !Array.isArray(posts)){
        return(
            <div className='postPreviewContainer'>
                <p>Posts not found.</p>
            </div>
        )
    }
    return(
        <div className='postPreviewContainer'>
            {posts.map((post) => <PostPreview post={post} key={post._id} />)}
        </div>
    )
}